/**
 * Samam Aparam Prayogams Data Module for ahobilam.com-2025
 * Devanagari Sanskrit Text + Tamil Translations (தமிழ் உரை / தாற்பரியம்)
 */

export const SAMAM_APARAM_DATA = {
  "apara-samskara-intro": {
    id: "apara-samskara-intro",
    titleDeva: "अपरप्रयोगः संस्कारनिर्णयः",
    titleTamil: "அபர பிரயோக அவதாரிகை மற்றும் சம்ஸ்கார நிர்ணயம்",
    veda: "Samam",
    category: "Aparam",
    pageNumber: 229,
    content: [
      {
        deva: "अथातो ऽपरप्रयोगं व्याख्यास्यामः । औपासनाग्निना दहनकर्मणा संस्करिष्ये ॥",
        tamilTranslit: "அதா²தோ ऽபரப்ரயோக³ம் வ்யாக்யாஸ்யாமஃ । ஔபாஸநாக்³நிநா த³ஹநகர்மணா ஸம்ஸ்கரிஷ்யே ॥",
        tamilMeaning: "இனி அபர சடங்குகளின் விதியைக் கூறுகிறோம். ஔபாஸன அக்னியைக் கொண்டு தஹன சம்ஸ்காரத்தைச் செய்ய வேண்டும்."
      }
    ]
  },
  "dahana-krama": {
    id: "dahana-krama",
    titleDeva: "दहनकर्म विधिः",
    titleTamil: "தஹன கர்ம விதி (ஈமக் கிரியை)",
    pageNumber: 230,
    content: [
      {
        deva: "गच्छाम्रमध्वनः सर्वमेषवस्युहृदौ दिवम् । परं व्योम नयध्वं गच्छन्तं स्थानमुत्तमम् ॥",
        tamilTranslit: "க³ச்சா²ம்ரமத்⁴வநஃ ஸர்வமேஷவஸ்யுஹ்ரு'தௌ³ தி³வம் । பரமம் வ்யோம நயத்⁴வம் க³ச்ச²ந்தம் ஸ்தா²நமுத்தமம் ॥",
        tamilMeaning: "ஆன்மா தனது நல்ல வினைகளின் பயனாக உத்தமமான பரமபத உலகத்தை அடையட்டும்."
      },
      {
        deva: "अग्ने नय सुपथा राये अस्मान् विश्वानि देव वयुनानि विद्वान् ।",
        tamilTranslit: "அக்³நே நய ஸுபதா² ராயே அஸ்மான் விஶ்வாநி தே³வ வயுநாநி வித்³வான் ।",
        tamilMeaning: "அக்னி தேவனே! எங்களை நல்வழியில் நற்பேறுகளுக்கு அழைத்துச் செல்வாயாக."
      }
    ]
  },
  "sanchayana-krama": {
    id: "sanchayana-krama",
    titleDeva: "अस्थिसञ्चयन विधिः",
    titleTamil: "அஸ்தி சஞ்சயன விதி (அஸ்தி சேகரித்தல்)",
    pageNumber: 240,
    content: [
      {
        deva: "द्वितीये तृतीये वा अहनि अस्थिसञ्चयनं कुर्यात् ।",
        tamilTranslit: "த்விதீயே த்ரு'தீயே வா அஹநி அஸ்திஸஞ்சயநம் குர்யாத் ।",
        tamilMeaning: "2ஆம் அல்லது 3ஆம் நாளில் அஸ்தி சஞ்சயனம் செய்ய வேண்டும்."
      }
    ]
  },
  "ekadasaha-sapindikarana": {
    id: "ekadasaha-sapindikarana",
    titleDeva: "एकादशाहः सपिण्डीकरणम्",
    titleTamil: "ஏகாதசாஹம் மற்றும் சபிண்டீகரணம் (11 மற்றும் 12ஆம் நாள் சடங்குகள்)",
    pageNumber: 250,
    content: [
      {
        deva: "एकादशे ऽहनि एकोद्दिष्ट श्राद्धं कुर्यात् । द्वादशे ऽहनि सपिण्डीकरणम् ।",
        tamilTranslit: "ஏகாத³ஶே ऽஹநி ஏகோத்³தி³ஷ்ட ஶ்ராத்³த⁴ம் குர்யாத் । த்வாத³ஶே ऽஹநி ஸபிண்டீ³கரணம் ।",
        tamilMeaning: "11ஆம் நாளில் ஏகோத்திஷ்ட சிரார்த்தமும், 12ஆம் நாளில் சபிண்டீ கரணமும் செய்ய வேண்டும்."
      }
    ]
  },
  "apara-shraddha-prayogah": {
    id: "apara-shraddha-prayogah",
    titleDeva: "श्राद्धप्रयोगः पिण्डप्रदानम्",
    titleTamil: "அபர சிரார்த்த பிரயோகம் மற்றும் பிண்ட பிரதானம் (மாதாந்திர & வருடாந்திர சிரார்த்தம்)",
    pageNumber: 260,
    content: [
      {
        deva: "मासि मासि अहरहः स्वधाभ्यः । पितृभ्यः स्वधायिभ्यः स्वधा नमः ॥",
        tamilTranslit: "மாஸி மாஸி அஹரஹஃ ஸ்வதா⁴ப்⁴யஃ । பித்ரு'ப்⁴யஃ ஸ்வதா⁴யிப்⁴யஃ ஸ்வதா⁴ நமஃ ॥",
        tamilMeaning: "மாதம்தோறும் மற்றும் வருடாந்திர சிரார்த்தங்களில் பித்ருக்களுக்கு ஸ்வதா நமஸ்காரத்துடன் பிண்டப் பிரதானம் செய்கிறேன்."
      }
    ]
  },
  "vrishti-varuna-prayoga": {
    id: "vrishti-varuna-prayoga",
    titleDeva: "वृष्टिप्रद वरुणजयप्रयोगः",
    titleTamil: "வருண ஜப பிரயோகம் (மழை வேண்டிச் செய்யும் பிரயோகம்)",
    pageNumber: 270,
    content: [
      {
        deva: "अथातः सम्प्रवक्ष्यामि कर्म वृष्टिप्रदायकम् । शालिहोत्रेण मुनिना प्रोक्तं लोकहिताय च ॥",
        tamilTranslit: "அதா²தஃ ஸம்ப்ரவக்ஷ்யாமி கர்ம வ்ரு'ஷ்டிப்ரதா³யகம் । ஶாலிஹோத்ரேண முநிநா ப்ரோக்தம் லோகஹிதாய ச ॥",
        tamilMeaning: "உலக நன்மைக்காகப் பொழியும் மழையைப் பெற வேண்டி சாலிஹோத்ர முனிவரால் அருளப்பட்ட வருண ஜப விதியைக் கூறுகிறோம்."
      }
    ]
  }
};
